import {
  Box,
  Paper,
  Grid,
  Chip,
  makeStyles,
  Typography,
  Switch,
  FormControlLabel
} from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import { components, useServices } from 'cng-web-lib'
import { useHistory, useLocation } from 'react-router-dom'
import CngBackdrop from '../components/CngBackdrop'
import { useFormContext } from 'react-hook-form'
import TradeManagementTranslationText from '../shared/TradeManagementTranslationText'
import CommonFtaTranslationText from 'src/views/common/CommonFtaTranslationText'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowRight } from '@fortawesome/pro-light-svg-icons'
import { faLacrosseStick } from '@fortawesome/pro-light-svg-icons'
import Utils from 'src/shared/Utils'
import GoBackButton from 'src/components/button/GoBackButton'

const { CngGridItem } = components

const useStyles = makeStyles((theme) => ({
  sectionPrimaryLabel: {
    color: theme.palette.text.widgetTitle
  },
  sectionSecondaryLabel: {
    color: theme.palette.text.textSecondary
  },
  sectionSummaryCardHeader: {
    backgroundColor: theme.palette.background.white
  }
}))

const FORM_INITIAL_VALUES = Object.freeze({})

const FormBody = ({ disabled, ...props }) => {
  const classes = useStyles()

  // Locale
  const FtaTranslatedTextsObject = TradeManagementTranslationText()
  const CommonFtaTranslatedTextsObject = CommonFtaTranslationText()

  return (
    <Grid container spacing={1}>
      <CngGridItem item xs={12} sm={12}>
        <div
          className={`cng-summary-header ${classes.sectionSummaryCardHeader}`}
        >
          <div className={`cng-summary-header-col`}>
            <span className={`summary-count-label-wrapper`}>
              <label className={`${classes.sectionSecondaryLabel}`}>
                {props.shownCount} {CommonFtaTranslatedTextsObject.item}
                {props.shownCount > 0 ? `(s)` : ``}
              </label>
            </span>
          </div>

          <div
            className={`cng-summary-header-col auto cta-btn-wrapper flex-end`}
          >
            <FormControlLabel
              value='advanced-mode'
              control={
                <Switch
                  color='primary'
                  onChange={props.onShouldShowDeleteChange}
                />
              }
              label={'Include deleted activity items'}
              labelPlacement='start'
            />
            {/* Search bar goes here */}
          </div>
        </div>
      </CngGridItem>
    </Grid>
  )
}

const FtaActivityHistoryListHeaderComponent = Object.freeze({
  FormBody: FormBody,
  initialValues: FORM_INITIAL_VALUES
})

export default FtaActivityHistoryListHeaderComponent
